<template>
 <div class="container" id="copyright">
  <section>
    <div class="row">
      <div class="col-12">
        <div class="page section-group">
          <div class="card p-5">
            <h1 class="page-title mb-2"> {{$t('common.copyright.t1')}} </h1>
            <hr class="divider">
            <div class="page-content mb-4">
              <div class="copyright section-group">
                <p>{{$t('common.copyright.t2')}}</p>
                <h3>{{$t('common.copyright.t3')}}</h3>
                <h3>{{$t('common.copyright.t4')}}</h3>
                <p>{{$t('common.copyright.t5')}} <a href="mailto:info@soonnet.org" target="_blank">info@soonnet.org</a>：</p>
                <ol type="a">
                  <li>{{$t('common.copyright.t7')}}</li>
                  <li>{{$t('common.copyright.t8')}}</li>
                  <li>{{$t('common.copyright.t9')}}</li>
                  <li>{{$t('common.copyright.t10')}}</li>
                  <li>{{$t('common.copyright.t11')}}</li>
                  <li>{{$t('common.copyright.t12')}}</li>
                </ol>
                <p>{{$t('common.copyright.t13')}} <a href="mailto:info@soonnet.org" target="_blank">info@soonnet.org</a></p>
                <h3>{{$t('common.copyright.t14')}}</h3>
                <p>{{$t('common.copyright.t15')}}</p>
                <p>{{$t('common.copyright.t16')}}</p>
                <p>{{$t('common.copyright.t17')}}</p>
                <ol type="a">
                  <li>{{$t('common.copyright.t18')}}</li>
                  <li>{{$t('common.copyright.t19')}}</li>
                  <li>{{$t('common.copyright.t20')}}</li>
                  <li>{{$t('common.copyright.t21')}}</li>
                  <li>{{$t('common.copyright.t22')}}</li>
                  <li>{{$t('common.copyright.23')}}</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ./頁面內容 --> 
</div>
</template>
<script>
export default {
  data() {},
   created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/copyright.vue